import createNamespaceContext from './helper/createNamespaceContext';
export var ROVO_EXTENSION_CONTEXT = 'rovoExtensionCtx';
export var RovoExtensionAnalyticsContext = createNamespaceContext(ROVO_EXTENSION_CONTEXT, 'RovoExtensionAnalyticsContext');